import React, { useEffect, useRef, useState } from 'react';
import './EngineFlowCompact.css';
import e1 from '../../assets/images/engine/engine-1.png';
import e2 from '../../assets/images/engine/engine-2.png';
import e3 from '../../assets/images/engine/engine-3.png';
import e4 from '../../assets/images/engine/engine-4.png';
import e5 from '../../assets/images/engine/engine-5.png';

export default function EngineFlowCompact() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => setVisible(true), 180);
            io.disconnect();
          }
        });
      },
      { threshold: 0.15 }
    );
    io.observe(node);
    return () => io.disconnect();
  }, []);

  const items = [
    { id: 1, img: e1, title: 'Validated mAb Library', desc: 'Strategic access to a large, curated panel of validated monoclonal antibodies across diverse oncology targets.', cta: 'No antibody generation from scratch' },
    { id: 2, img: e2, title: 'High-Throughput Screening', desc: 'In-house capabilities to rapidly screen 10-15 clones per target for binding and specificity.', cta: 'ELISA, Flow, IHC validation' },
    { id: 3, img: e3, title: 'AI-Powered Humanization', desc: 'In-house AI-assisted pipeline for rapid humanization and sequence optimization — weeks, not months.', cta: 'Weeks, not months' },
    { id: 4, img: e4, title: 'Functional Validation', desc: 'Internalization and developability assays testing for lead selection to de-risk early development.', cta: 'De-risk early development' },
    { id: 5, img: e5, title: 'Lead Candidate', desc: 'Optimized, validated antibody ready for ADC conjugation and IND-enabling studies.', cta: 'Clinical-ready asset' },
  ];

  return (
    <div className={`ef-compact ${visible ? 'visible' : 'hidden'}`} ref={ref}>
      {items.map((it, idx) => (
        <div className="card" key={it.id} style={{ transitionDelay: `${idx * 100}ms` }}>
          <div className="badge" aria-hidden="true">{it.id}</div>
          <div className="media"><img src={it.img} alt="" /></div>
          <div className="body">
            <h4>{it.title}</h4>
            <p>{it.desc}</p>
          </div>
          <div className="card-cta" aria-hidden="true">{it.cta}</div>
        </div>
      ))}
    </div>
  );
}

